import React from 'react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero" 
      className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 min-h-[600px] flex items-center"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzY3NTM2MDYxfDA&ixlib=rb-4.1.0&q=85)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#1e3a8a]/95 to-[#1e3a8a]/85"></div>
      
      {/* Content */}
      <div className="relative max-w-7xl mx-auto text-center w-full">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Powering Government & Enterprise
          <br />
          Technology Procurement
        </h1>
        <p className="text-lg sm:text-xl text-gray-100 mb-10 max-w-3xl mx-auto leading-relaxed">
          Authorized technology partner delivering IT hardware and enterprise solutions with reliability and compliance.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            onClick={() => scrollToSection('partners')}
            className="bg-white text-[#1e3a8a] hover:bg-gray-100 px-8 py-6 text-lg rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            Our Partners
          </Button>
          <Button
            onClick={() => scrollToSection('contact')}
            variant="outline"
            className="border-2 border-white text-white hover:bg-white hover:text-[#1e3a8a] px-8 py-6 text-lg rounded-lg transition-all duration-200 shadow-lg"
          >
            Contact Us
          </Button>
        </div>
      </div>
    </section>
  );
};